<template>
  <v-autocomplete
    v-model="selected"
    variant="underlined"
    :items="list"
    item-title="fullLabel"
    item-value="clientId"
    label="Responses"
    hide-no-data
    return-object
    hide-selected
    clearable
    :filter="customFilter"
    required
    :rules="requiredRules"
  ></v-autocomplete>
</template>

<script>
export default {
  name: 'AnswerChooser',
  props: {
    answer: Object,
    list: Array,
    modelValue: String
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selected: this.answer || undefined,
      requiredRules: [v => !!v || 'Required']
    }
  },
  methods: {
    customFilter(item, queryText, itemText) {
      return itemText.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    }
  },
  watch: {
    selected(newValue) {
      this.$emit('onSelect', newValue)
      this.$emit('update:modelValue', newValue ? newValue.clientId : '')
    },
    answer(newValue) {
      if (!newValue) return
      if (!newValue.clientId) {
        this.selected = undefined
      }
    }
  }
}
</script>
